"use client"

import { useRef, type ButtonHTMLAttributes } from "react"
import {
    TextScrambleAnimation,
    type TextScrambleAnimationHandle,
} from "./scramble-text"
import { cn } from "@/lib/utils"

export function ScrambleButton({
    children,
    text,
    className,
    textContainerClassName,
    uppercase,
    ...rest
}: ButtonHTMLAttributes<HTMLButtonElement> & {
    text: string
    textContainerClassName?: string
    uppercase?: boolean
}) {
    const scrambleRef = useRef<TextScrambleAnimationHandle | null>(null)

    const handleMouseEnter = () => {
        scrambleRef.current?.play()
    }

    return (
        <button
            className={cn("relative cursor-pointer", className)}
            onMouseEnter={handleMouseEnter}
            {...rest}
        >
            <TextScrambleAnimation
                text={text}
                ref={scrambleRef}
                uppercase={uppercase}
                className={cn(textContainerClassName)}
            />
            {children}
        </button>
    )
}
